import React from 'react';

import type { ColumnMeta, ColumnType, TableVerticalAlign } from '../types';
import TableRow from './TableRow';

type TableBodyProps<T> = {
  data: T[];
  columns: ColumnMeta<T>[];
  clampCells?: boolean;
  cellsClassName?: string;
  cellsContentClassName?: string;
  verticalAlign: TableVerticalAlign;
  onRowClick?: (row: T) => void;
  getRowKey?: (row: T, index: number) => React.Key;
  getRowProps?: (
    row: T,
    index: number
  ) => React.HTMLAttributes<HTMLTableRowElement>;
  getCellProps?: (
    row: T,
    column: ColumnType<T>,
    rowIndex: number,
    columnIndex: number
  ) => React.TdHTMLAttributes<HTMLTableCellElement>;
};

const TableBody = <T,>({
  data,
  columns,
  clampCells,
  cellsClassName,
  cellsContentClassName,
  verticalAlign,
  onRowClick,
  getRowKey,
  getRowProps,
  getCellProps,
}: TableBodyProps<T>) => {
  return (
    <tbody>
      {data.map((row, index) => {
        if (!row) return null;

        return (
          <TableRow
            key={getRowKey?.(row, index) ?? index}
            row={row}
            rowIndex={index}
            columns={columns}
            clampCells={clampCells}
            cellsClassName={cellsClassName}
            cellsContentClassName={cellsContentClassName}
            verticalAlign={verticalAlign}
            isLastRow={index === data.length - 1}
            onRowClick={onRowClick}
            rowProps={getRowProps?.(row, index)}
            getCellProps={getCellProps}
          />
        );
      })}
    </tbody>
  );
};

export default React.memo(TableBody) as typeof TableBody;
